import React from "react"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import HistoryList from "./HistoryList"
import "./HistoryListModal.css"

// `fields` narrows the log to one column's history, e.g. ["charge_dayofweek"]; omit it for every change.
// `defaultRange` is the window it opens on, e.g. "days:30"; omit it for the last 7 days.
function HistoryListModal({ isOpen, toggle, title = "History", objectIds = [], fields = null, defaultRange, emptyText = "No history found yet.", }) {
    const normalizedObjectIds = (objectIds || []).filter(Boolean)

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered className="history-list-modal">
            {/* <ModalHeader toggle={toggle} close={closeButton}>{title}</ModalHeader> */}
            <ModalBody className="history-list-modal__body">
                <div className="history-list-modal__content">
                    <HistoryList
                        objectIds={normalizedObjectIds}
                        fields={fields}
                        defaultRange={defaultRange}
                        emptyText={emptyText}
                    />
                </div>
            </ModalBody>
            <ModalFooter className="history-list-modal__footer">
                <button type="button" className="history-list-modal__close" onClick={toggle} aria-label="Close">
                    CLOSE
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default HistoryListModal
